import { canv } from '@/canv/global.js'
import {toolBase} from '@/tools/toolBase';

import { Group } from '@/group';

import { arrowWidget } from '@/elements/arrow.js'
import { selectionManager } from '../cursorTool';

export class arrowTool extends toolBase {

    constructor() {
        super();

        this.lineTypes = {
            "straight" : `
                <svg width="19" height="19" viewBox="0 0 123 114" fill="none" xmlns="http://www.w3.org/2000/svg">
                <line x1="2.63695" y1="111.418" x2="120.637" y2="3.41815" stroke="black" stroke-width="7"/>
                </svg>
            `,
            "quadratic" : `
                <svg width="19" height="19" viewBox="0 0 112 124" fill="none" xmlns="http://www.w3.org/2000/svg">
                <line x1="3.5" y1="120.5" x2="58.5" y2="120.5" stroke="black" stroke-width="7" stroke-linecap="round"/>
                <line x1="59.5" y1="3.5" x2="108.5" y2="3.5" stroke="black" stroke-width="7" stroke-linecap="round"/>
                <line x1="59.5" y1="4.5" x2="59.5" y2="120.5" stroke="black" stroke-width="7" stroke-linecap="round"/>
                </svg>
            `,
            "curved" : `
                <svg width="19" height="19" viewBox="0 0 146 150" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M128.107 16.9167C17.6949 11.498 128.107 136.998 17.6949 132.715" stroke="black" stroke-width="7"/>
                <rect x="113" y="8" width="6" height="18" fill="white"/>
                <rect x="27" y="123" width="6" height="18" fill="white"/>
                </svg>
            `
        };
    }

    getToolView() {
        return `
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M23.2807 7.21979L20.2807 4.21979C20.14 4.07906 19.9491 4 19.7501 4C19.5511 4 19.3602 4.07906 19.2195 4.21979C19.0787 4.36052 18.9997 4.55139 18.9997 4.75042C18.9997 4.94944 19.0787 5.14031 19.2195 5.28104L20.9398 7.00042H19.7501C15.1254 7.00042 14.0267 9.63667 13.0582 11.9617C12.1788 14.072 11.472 15.767 8.41947 15.9779C8.22792 15.0686 7.70554 14.2627 6.95361 13.7166C6.20168 13.1706 5.27377 12.9231 4.34977 13.0223C3.42577 13.1215 2.57152 13.5602 1.95262 14.2535C1.33372 14.9467 0.994265 15.845 1.00007 16.7743C1.00588 17.7036 1.35653 18.5976 1.98405 19.2831C2.61157 19.9685 3.47124 20.3965 4.39641 20.4842C5.32158 20.5718 6.24632 20.3128 6.99137 19.7573C7.73641 19.2019 8.24868 18.3896 8.42885 17.4779C12.4845 17.2295 13.5232 14.7451 14.442 12.5382C15.3823 10.2817 16.1248 8.50042 19.7501 8.50042H20.9398L19.2195 10.2198C19.0787 10.3605 18.9997 10.5514 18.9997 10.7504C18.9997 10.9494 19.0787 11.1403 19.2195 11.281C19.3602 11.4218 19.5511 11.5008 19.7501 11.5008C19.9491 11.5008 20.14 11.4218 20.2807 11.281L23.2807 8.28104C23.3505 8.21139 23.4058 8.12867 23.4435 8.03762C23.4813 7.94657 23.5007 7.84898 23.5007 7.75042C23.5007 7.65186 23.4813 7.55426 23.4435 7.46321C23.4058 7.37216 23.3505 7.28945 23.2807 7.21979ZM4.7501 19.0004C4.30509 19.0004 3.87007 18.8685 3.50006 18.6212C3.13005 18.374 2.84167 18.0226 2.67137 17.6115C2.50107 17.2003 2.45651 16.7479 2.54333 16.3115C2.63015 15.875 2.84444 15.4741 3.15911 15.1594C3.47378 14.8448 3.87469 14.6305 4.31114 14.5436C4.7476 14.4568 5.2 14.5014 5.61114 14.6717C6.02227 14.842 6.37367 15.1304 6.6209 15.5004C6.86814 15.8704 7.0001 16.3054 7.0001 16.7504C7.0001 17.3472 6.76305 17.9194 6.34109 18.3414C5.91913 18.7634 5.34683 19.0004 4.7501 19.0004Z" fill="#2C2D32"/>
            </svg>
        `;
    }

    getToolTipName() {
        return "Соединительные линии";
    }

    getToolHotKey() {
        return "L";
    }

    select() {

        super.select();
        this.openSubMenu();

        var pt = canv.actionManager.getActionPoint();

        this.creationX = pt.x;
        this.creationY = pt.y;
    }

    unselect() {
        super.unselect();

        this.ghostArrow = null;
        this.firstPointMaster = null;
        this.closeSubMenu();
    }

    getWidgetWrapper() {
        var newArrow = new arrowWidget(0, 0, 0, 0);

        newArrow.color = this.color;
        newArrow.lineWidth = this.lineWidth;
        newArrow.lineType = this.lineType;
        newArrow.updateDims();
        newArrow.dashType = this.dashType;
        newArrow.firstEndType = this.firstEndType;
        newArrow.lastEndType = this.lastEndType;

        var newGroup = new Group(true);
        newArrow.setParent(newGroup);
        return newGroup;
    }

    openSubMenu() {
        var subMenu = document.createElement('div');
        subMenu.classList.add("arrowTool_subMenu");
        document.body.prepend(subMenu);

        var template = ``;

        template += `<div class="arrowTool_subMenu_container" mode="straight">` + this.lineTypes["straight"] + `</div>`;
        template += `<div class="arrowTool_subMenu_container" mode="quadratic">` + this.lineTypes["quadratic"] + `</div>`;
        template += `<div class="arrowTool_subMenu_container" mode="curved">` + this.lineTypes["curved"] + `</div>`;

        subMenu.innerHTML = template;

        var modes = document.getElementsByClassName('arrowTool_subMenu_container');
        for (var i = 0; i < modes.length; i++) {
            var mode = modes[i].getAttribute("mode");
            if (mode == this.lineType) {
                modes[i].classList.add("arrowTool_subMenu_selected");
            }
            modes[i].addEventListener('mouseup', this.subMenuItemClick.bind(this, mode), false);
        }


        var menuItem = document.getElementsByClassName(this.getToolClass())[0];
        var menuSize = menuItem.getBoundingClientRect();
        subMenu.style.top = (menuSize.top - (subMenu.getBoundingClientRect().height - menuSize.height) / 2).toString() + "px";

        subMenu.style.transform = "translate(0px)";
        subMenu.style.opacity = "1";
    }

    closeSubMenu() {
        var subMenu = document.getElementsByClassName('arrowTool_subMenu')[0];
        subMenu.outerHTML = "";
    }

    subMenuItemClick(mode) {
        this.lineType = mode;
        var modes = document.getElementsByClassName('arrowTool_subMenu_container');
        for (var i = 0; i < modes.length; i++) {
            var mode = modes[i].getAttribute("mode");
            modes[i].classList.remove("arrowTool_subMenu_selected");
            if (mode == this.lineType) {
                modes[i].classList.add("arrowTool_subMenu_selected");
            }
        }
    }



    // setters

    setColor(color) {
        this.color = color;
    }

    setLineWidth(lineWidth) {
        this.lineWidth = lineWidth;
    }

    setLineType(lineType) {
        this.lineType = lineType;
    }

    setDashType(dashType) {
        this.dashType = dashType;
    }

    setFirstEndType(firstEndType) {
        this.firstEndType = firstEndType;
    }

    setLastEndType(lastEndType) {
        this.lastEndType = lastEndType;
    }




    // TryAction




    TryAction(type) {
        canv.redraw();

        if (type == "mousedown") {

            var createdArrowWrapper = this.getWidgetWrapper();

            var pt = canv.actionManager.getActionPoint();


            createdArrowWrapper.onlyChild().getFirstPoint()["x"] = pt.x;
            createdArrowWrapper.onlyChild().getFirstPoint()["y"] = pt.y;

            createdArrowWrapper.onlyChild().getLastPoint()["x"] = pt.x;
            createdArrowWrapper.onlyChild().getLastPoint()["y"] = pt.y;


            // Добавляем стрелку
            canv.canvasController.addGroup(createdArrowWrapper);
            canv.eventManager.openRecord();
            canv.eventManager.createBuildEvent("create", createdArrowWrapper);


            for (var i = canv.canvasController.items.length - 1; i >= 0; i--) {
                var res = canv.canvasController.items[i].TryMagnet(createdArrowWrapper.onlyChild(), "firstPoint", true);
                if (res["status"]) {
                    createdArrowWrapper.onlyChild().firstPointPlace = res["place"];
                    createdArrowWrapper.onlyChild().getFirstPoint()["x"] = res["x"];
                    createdArrowWrapper.onlyChild().getFirstPoint()["y"] = res["y"];
                }
            }

            canv.eventManager.closeRecord();


            createdArrowWrapper.onlyChild().updateDims();

            var cursorTool = canv.toolBox.TryGetToolByName("cursorTool");
            selectionManager.setSelected([createdArrowWrapper], false);
            createdArrowWrapper.fixWidgets("resize");
            cursorTool.turnMode("resize");
            cursorTool.catchPointer = "lastPoint";
        } else if (type == "mousemove") {
            var pt = canv.actionManager.getActionPoint();

            this.creationX = pt.x;
            this.creationY = pt.y;

            for (var i = canv.canvasController.items.length - 1; i >= 0; i--) {
                var res = canv.canvasController.items[i].TryMagnet(null, "firstPoint");
                if (res["status"]) {
                    this.creationX = res["x"];
                    this.creationY = res["y"];
                }
            }

        }

    }



    // Draw

    draw() {

        var pointerSize = canv.actionManager.getZoomConstant(10);

        canv.ctx.fillStyle = "white";
        canv.ctx.strokeStyle = "#0B99FF";
        canv.ctx.lineWidth = pointerSize / 4;

        canv.ctx.beginPath();
        canv.ctx.arc(this.creationX, this.creationY, pointerSize / 2, 0, 2 * Math.PI);
        canv.ctx.stroke();
        canv.ctx.fill();
        canv.ctx.closePath();

    }



    name = "arrowTool";
    creationX = 0;
    creationY = 0;

    lineWidth = 1;
    color = "black";
    lineType = "curved";
    dashType = "solid";
    firstEndType = "none";
    lastEndType = "filled";
}
